import {CheckOutlined, SettingOutlined} from '@ant-design/icons';
import {Button, Modal} from 'antd';
import {useAtom} from 'jotai';

import {personalizationDoneAtom} from '@atoms/personalization';
import {useBreakpoint} from '@hooks/useBreakpoint';
import {AccentPicker} from '@components/AccentPicker';
import {ThemePicker} from '@components/ThemePicker';

import styles from './PersonalizationModal.module.scss';

/**
 * Онбординг персонализации. Показывается при первом входе пока
 * `personalizationDoneAtom === false`. После клика «Готово» флаг
 * ставится в `true` и больше не показывается.
 */
export const PersonalizationModal = () => {
  const [done, setDone] = useAtom(personalizationDoneAtom);
  const {isMobile} = useBreakpoint();

  const handleClose = () => setDone(true);

  return (
    <Modal
      open={!done}
      onCancel={handleClose}
      width={isMobile ? '94%' : 720}
      footer={null}
      title={null}
      closable={false}
      maskClosable={false}
      centered
    >
      <div className={styles.root}>
        <header className={styles.hero}>
          <div className={styles.heroIcon}>
            <SettingOutlined />
          </div>
          <div>
            <h2 className={styles.heroTitle}>Персонализация</h2>
            <p className={styles.heroSubtitle}>Настройте интерфейс под себя — это займёт минуту.</p>
          </div>
        </header>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>Тема</h3>
          <p className={styles.sectionDescription}>Светлая, тёмная или по системе.</p>
          <ThemePicker />
        </section>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>Цвет акцента</h3>
          <p className={styles.sectionDescription}>
            Применяется к кнопкам, ссылкам и активным пунктам меню.
          </p>
          <AccentPicker />
        </section>

        <footer className={styles.footer}>
          <p className={styles.footerHint}>
            Все эти настройки можно изменить позже в разделе <strong>Настройки</strong>.
          </p>
          <Button
            type="primary"
            size="large"
            icon={<CheckOutlined />}
            onClick={handleClose}
            block={isMobile}
          >
            Готово
          </Button>
        </footer>
      </div>
    </Modal>
  );
};
